module.exports = __webpack_public_path__ + "static/img/app03.de5e2067.png";